define('LiveOrder.Model.Extension',
['LiveOrder.Model',
		'Tracker',
		'underscore',

	], function
	(LiveOrderModel,
		Tracker,
		_
) {

	_.extend(LiveOrderModel.prototype, {

		removeLine: _.wrap(LiveOrderModel.prototype.removeLine, function (fn) {
			var removed = _.toArray(arguments).slice(1);
			var deleted = fn.apply(this, _.toArray(arguments).slice(1));
      var self = this;
      
      Tracker.getInstance().trackRemoveFromCart(removed)
		})

		// @method checkLeaseItems
		// @desc check if exist one item with the field custitem_requires_lease in true and
		// set the body field custbody_lease_status with the value "1" (required)

	})

});
